import { mtDate } from "./dates";


export const CARRIERS = [
  { id: "usps", label: "USPS", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=" },
  { id: "ups", label: "UPS", url: "https://www.ups.com/track?tracknum=" },
  { id: "fedex", label: "FedEx", url: "https://www.fedex.com/fedextrack/?trknbr=" },
  { id: "other", label: "Other carrier" },
];

export const cleanTracking = (n) => (n || "").replace(/\s+/g, "").toUpperCase();

export const buildTrackingUrl = (carrier, number) => {
  const c = CARRIERS.find((x) => x.id === carrier);
  const n = cleanTracking(number);
  return c?.url && n ? `${c.url}${n}` : "";
};

export const carrierLabel = (s) =>
  s.carrier === "other" ? s.carrier_name || "Other carrier" : CARRIERS.find((c) => c.id === s.carrier)?.label || "Carrier";

export function orderStep(o) {
  if (["cancelled", "expired", "refunded"].includes(o.status)) return o.status;
  if (o.status === "delivered") return "delivered";
  if (o.status === "shipped") return "shipped";
  if (o.status === "partially_shipped") return "partly";
  if (o.payment_status !== "paid") return "unpaid";
  if (o.supplier_ordered_at) return "supplier";
  return "new";
}

export const NOT_SHIPPED_STEPS = ["new", "supplier", "partly"];

export const isWaitingOnSupplier = (o) => !!o.supplier_ordered_at && ["supplier", "partly"].includes(orderStep(o));

export const daysSincePaid = (o) => Math.floor((Date.now() - new Date(o.paid_at || o.created_at).getTime()) / 86400000);

export const isOverdue = (o) => NOT_SHIPPED_STEPS.includes(orderStep(o)) && daysSincePaid(o) >= 3;

export const shortDate = (iso) => mtDate(iso, { month: "short", day: "numeric" });

const CUSTOMER_LABELS = {
  pending: "Pending",
  paid: "Paid",
  partially_shipped: "Partly shipped",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
  expired: "Expired",
};

export const customerStatusLabel = (status) => CUSTOMER_LABELS[status] || status;
